import axios from "./index";

class ClientesApi {
  static fetchClientes = () => {
    return axios.get(`/procesos/clientes/`);
  };
  static fetchClienteByIdentificacion = (identificacion) => {
    return axios.get(`/procesos/clientes/${identificacion}/consultar/`);
  };

  static createCliente = (data) => {
    return axios.post(`/procesos/clientes/crear/`, data);
  };

  static updateCliente = (id, data) => {
    return axios.put(`/procesos/clientes/${id}/actualizar/`, data);
  };

  static deleteCliente = (id) => {
    return axios.delete(`/procesos/clientes/${id}/eliminar/`);
  };
}
export default ClientesApi;
